export const addonsEmceePublicRoute = {
	name: 'addons-emcee-public',
	path: '/plugins/servlet/ac/com.atlassian.jira.emcee/enduser-discover',
};
